import { __ } from '@wordpress/i18n';
import { ToggleControl } from '@wordpress/components';
// import './style.scss';

const ToggleSwitch = ({ label, checked, onChange }) => {
    return (
        <div className="kanews-toggle-control kanews-control-item">
            <ToggleControl
                label={label}
                checked={checked}
                onChange={onChange}
                __nextHasNoMarginBottom={true}
                __next40pxDefaultSize={true}
            />
        </div>
    );
};

export default ToggleSwitch; 